import { defineComponent as _defineComponent } from 'vue'
import StoreUploadList from '../components/StoreUploadList.vue';
import router from '../router/index'


export default /*#__PURE__*/_defineComponent({
  __name: 'StoreUploadsView',
  setup(__props) {


const breadcrumbItems = [
  {
    text: 'Stores',
    disabled: false,
    href: router.match({
      name: 'stores',
    }).path,
  },
  {
    text: router.currentRoute.params.store,
    disabled: false,
    href: router.match({
      name: 'storeUploads',
      params: {
        store: router.currentRoute.params.store,
      },
    }).path,
  },
]


return { __sfc: true,breadcrumbItems, StoreUploadList }
}

})